import VerticalPage from "@/components/marketing/VerticalPage";
import { Wallet, BadgePercent, Users, BarChart3, ShieldCheck, Network } from "lucide-react";

export default function Corporate() {
  return (
    <VerticalPage
      vertical="Corporate"
      hero={"Feed 10,000 employees a day. From one dashboard."}
      blurb={"Multi-vendor cafeterias, subsidised meals, employee wallets, and HRMS-grade reporting — Grubpe runs the entire food economy of your campus."}
      palette={{
        badge:  "bg-blue-50 text-blue-700",
        iconBg: "bg-blue-50 text-blue-700",
        kpi:    "bg-blue-50 text-blue-900 border border-blue-200",
      }}
      kpis={[
        { value: "₹0", label: "Cash on campus" },
        { value: "<3s",  label: "Average tap-to-pay" },
        { value: "12+",  label: "Vendors per location" },
        { value: "1",    label: "Wallet per employee" },
      ]}
      features={[
        { icon: Wallet,       title: "Employee wallets",        desc: "One pre-paid wallet per employee. Auto-recharge from payroll. Tap-to-pay at every counter and kiosk." },
        { icon: BadgePercent, title: "Subsidy rule engine",      desc: "Daily ₹100 cap, weekend free, ₹0 GST on subsidy portion, breakfast-only — whatever HR signs off on, the system enforces." },
        { icon: Users,        title: "SSO with HRMS",            desc: "SAML / OAuth login from your HRMS. New hire on Monday → wallet active on Monday." },
        { icon: BarChart3,    title: "Per-employee P&L",         desc: "Vendor-wise, project-wise, cost-centre-wise spend breakdown — pushed straight to your finance team's BI tool." },
        { icon: ShieldCheck,  title: "GST-compliant per vendor", desc: "Each multi-vendor cart auto-generates separate compliant invoices. Vendors stay individually liable. You stay clean." },
        { icon: Network,      title: "Plays nice with everything", desc: "Razorpay, Paytm, PhonePe, Cashfree, EDC terminals. Petpooja, UrbanPiper — for the vendors that won't switch their POS." },
      ]}
      useCases={[
        "Employee with ₹120 cart, ₹100 subsidy: pays ₹20 from wallet → automatic 3-way settlement (employer / employee / vendor).",
        "New hire signs into the cafeteria app via Workday SSO; wallet provisioned with this month's pro-rated subsidy.",
        "Vendor lead drops 15% on Wednesdays: anomaly alert lands in operations Slack channel by 2 PM the same day.",
        "Quarterly compliance audit: GST invoices, vendor settlements, expense ledger — exportable in three clicks.",
      ]}
    />
  );
}
